import React from 'react';

/** Native select styled to match Input. */
export default function Select({ label, hint, options = [], style, id, children, ...rest }) {
  // React.useId guarantees uniqueness when two same-labeled fields render; explicit id still wins.
  const autoId = React.useId();
  const selId = id || 'sel-' + autoId;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6, ...style }}>
      {label && (
        <label htmlFor={selId} style={{
          fontFamily: 'var(--font-sans)', fontWeight: 'var(--w-medium)', fontSize: 'var(--text-sm)',
          letterSpacing: 'var(--track-tight)', color: 'var(--ink)',
        }}>{label}</label>
      )}
      <div style={{ position: 'relative' }}>
        <select
          id={selId}
          style={{
            width: '100%', height: 44, padding: '0 40px 0 14px',
            appearance: 'none', WebkitAppearance: 'none',
            fontFamily: 'var(--font-sans)', fontSize: 'var(--text-base)', letterSpacing: 'var(--track-tight)',
            color: 'var(--ink)', background: 'var(--neutral-0)',
            border: '1.5px solid var(--line-strong)', borderRadius: 'var(--radius-md)',
            outline: 'none', cursor: 'pointer',
            transition: 'border-color var(--dur-fast) var(--ease-out)',
          }}
          onFocus={(e) => { e.currentTarget.style.borderColor = 'var(--ink)'; }}
          onBlur={(e) => { e.currentTarget.style.borderColor = 'var(--line-strong)'; }}
          {...rest}
        >
          {children || options.map((o) => {
            const opt = typeof o === 'string' ? { value: o, label: o } : o;
            return <option key={opt.value} value={opt.value}>{opt.label}</option>;
          })}
        </select>
        <span aria-hidden style={{
          position: 'absolute', right: 14, top: '50%', transform: 'translateY(-50%)',
          pointerEvents: 'none', color: 'var(--ink-muted)',
        }}>▾</span>
      </div>
      {hint && (
        <span style={{ fontFamily: 'var(--font-sans)', fontSize: 'var(--text-xs)', color: 'var(--ink-muted)' }}>
          {hint}
        </span>
      )}
    </div>
  );
}
